import { render, staticRenderFns } from "./MaccordionItemAlgoServer.vue?vue&type=template&id=9fa26d36&scoped=true"
import script from "./MaccordionItemAlgoServer.vue?vue&type=script&lang=js"
export * from "./MaccordionItemAlgoServer.vue?vue&type=script&lang=js"
import style0 from "./MaccordionItemAlgoServer.vue?vue&type=style&index=0&id=9fa26d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa26d36",
  null
  
)

export default component.exports